<template>
    <div>
        <span @dblclick="show" v-show="!show_form" style="cursor:pointer">
            {{ quantity_new }}
        </span>

        <div v-show="show_form">
            <div class="form-group">
                <input type="number"
                       step="1"
                       :min="quantity_old"
                       class="form-control input-sm"
                       v-model="edited_quantity_new">
            </div>
            <button @click="updateHistoryItem"
                    class="btn btn-primary"
                    v-text="trans('update_button', null)"
            ></button>
        </div>
    </div>
</template>

<script>
  let Functions = require("../../Functions");

    export default {
        props: ['quantity_old', 'quantity_new', 'state_item_id', 'current_route', 'translations'],
        data: function () {
            return {
                'show_form': false,
                'edited_quantity_new': this.quantity_new
            };
        },
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        },
        methods: {
            trans(name, path = 'stock') {
                return Functions.trans(this.translations, name, path);
            },
            show: function () {
                this.show_form = true;
            },
            updateHistoryItem: function () {
                if (this.checkQuantity()) {
                    this.updateQuantity(); return;
                }

                this.invalidQuantityAlert();
            },
            checkQuantity: function () {
                return this.edited_quantity_new > this.quantity_old;
            },
            invalidQuantityAlert: function () {
                alert(this.trans('error.quantity_new'));
            },
            updateQuantity: function () {
                this.$http.post(this.current_route + '/update', {
                    id: this.state_item_id,
                    quantity_new: this.edited_quantity_new
                }).then(() => {
                    this.show_form = false;
                    this.$root.$emit('update-table');
                }).catch(() => {
                    this.invalidQuantityAlert();
                });
            },
        },
    }
</script>
